import { z } from 'zod';

import { billingHistoryEntrySchema } from './billing-history.models';
import { paymentIdSchema, refundIdSchema, sessionChargeIdSchema } from './ids';
import { PAYMENT_METHODS } from './payment.commands';

export const paymentAppliedToSchema = z.object({
    sessionChargeId: sessionChargeIdSchema,
    date: z.iso.datetime(),
    serviceCode: z.string(),
    amountCents: z.number().int().min(1),
});

export type PaymentAppliedTo = z.infer<typeof paymentAppliedToSchema>;

export const paymentRefundSchema = z.object({
    id: refundIdSchema,
    number: z.number().int().min(1),
    refundedAt: z.iso.datetime(),
    amountCents: z.number().int().min(1),
});

export type PaymentRefund = z.infer<typeof paymentRefundSchema>;

export const paymentSchema = z.object({
    id: paymentIdSchema,
    number: z.number().int().min(1),
    paidAt: z.iso.datetime(),
    method: z.enum(PAYMENT_METHODS),
    checkNumber: z.string().nullable(),
    amountCents: z.number().int().min(1),
    appliedTo: z.array(paymentAppliedToSchema),
    history: z.array(billingHistoryEntrySchema),
    refund: paymentRefundSchema.nullable(),
});

export type Payment = z.infer<typeof paymentSchema>;

export const refundSchema = z.object({
    id: refundIdSchema,
    number: z.number().int().min(1),
    refundedAt: z.iso.datetime(),
    method: z.enum(PAYMENT_METHODS),
    checkNumber: z.string().nullable(),
    amountCents: z.number().int().min(1),
    payment: paymentSchema,
    history: z.array(billingHistoryEntrySchema),
});

export type Refund = z.infer<typeof refundSchema>;

export const PAYMENT_LIST_ITEM_KINDS = ['PAYMENT', 'REFUND'] as const;

export const paymentListItemSchema = z.discriminatedUnion('kind', [
    paymentSchema.extend({ kind: z.literal('PAYMENT') }),
    refundSchema.extend({ kind: z.literal('REFUND') }),
]);

export type PaymentListItem = z.infer<typeof paymentListItemSchema>;
